// extracted by mini-css-extract-plugin
export default {"menuToggle":"Menu_menuToggle__yjEbJ","menu":"Menu_menu__OJXzT","menu__hidde":"Menu_menu__hidde__17z02"};